var map = {
	"./icona-01guanggaopeizhibeifen.png": "./src/assets/images/menu/icona-01guanggaopeizhibeifen.png",
	"./icona-02jingyingpeizhibeifen.png": "./src/assets/images/menu/icona-02jingyingpeizhibeifen.png",
	"./icona-03jiaoseguanlibeifen.png": "./src/assets/images/menu/icona-03jiaoseguanlibeifen.png",
	"./icona-04yuangongguanlibeifen.png": "./src/assets/images/menu/icona-04yuangongguanlibeifen.png",
	"./icona-05shuiyinguanlibeifen.png": "./src/assets/images/menu/icona-05shuiyinguanlibeifen.png",
	"./icona-06dianpuliebiaobeifen.png": "./src/assets/images/menu/icona-06dianpuliebiaobeifen.png",
	"./icona-07dingdanliebiaobeifen.png": "./src/assets/images/menu/icona-07dingdanliebiaobeifen.png",
	"./icona-08shangpinliebiaobeifen.png": "./src/assets/images/menu/icona-08shangpinliebiaobeifen.png",
	"./icona-09renwuzhongxinbeifen.png": "./src/assets/images/menu/icona-09renwuzhongxinbeifen.png",
	"./icona-10gukeliebiaobeifen.png": "./src/assets/images/menu/icona-10gukeliebiaobeifen.png",
	"./iconcaidanguanli.png": "./src/assets/images/menu/iconcaidanguanli.png",
	"./icontubiaoku-25.png": "./src/assets/images/menu/icontubiaoku-25.png",
	"./paypalicon.png": "./src/assets/images/menu/paypalicon.png",
	"./report-push.png": "./src/assets/images/menu/report-push.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/menu sync recursive \\.png$";